<template lang="pug">
  .room.anchor-room(v-loading="loadingData")
    .divice-block-multi
      .divice-block(:class="warningFlag1")
        .divice-block-1
          DoubleGraph(:opts="humidity1" :series="humidity1Data")
        .divice-block-2
          SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" )
      .divice-block(:class="warningFlag2")
        .divice-block-1
          DoubleGraph(:opts="humidity2" :series="humidity2Data")
        .divice-block-2
          SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" )
    .divice-block-line
      SinglePieHistogramWrap.divice-block-line-item(:opts="SinglePieHistogramWrapOpts3" :series="SinglePieHistogramWrapData3" :class="warningFlag3")
      SinglePieHistogramWrap.divice-block-line-item(:opts="SinglePieHistogramWrapOpts4" :series="SinglePieHistogramWrapData4" :class="warningFlag4" )
      SinglePieHistogramWrap.divice-block-line-item(:opts="SinglePieHistogramWrapOpts5" :series="SinglePieHistogramWrapData5" :class="warningFlag5")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
import nizhouConfigJSON from './config/boxGirder_data.json'

export default {
  name: 'boxGirder',
  data() {
    return {
      timer: null,
      loadingData: false,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      warningFlag5: '',
      deviceList: [],
      humidity1: {
        title: '箱梁1区温湿度',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity1Data: {},
      humidity2: {
        title: '箱梁2区温湿度',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity2Data: {},
      SinglePieHistogramWrapData1: {},
      SinglePieHistogramWrapData2: {},
      SinglePieHistogramWrapData3: {},
      SinglePieHistogramWrapData4: {},
      SinglePieHistogramWrapData5: {},
      SinglePieHistogramWrapOpts1: {
        title: '箱梁1区温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts2: {
        title: '箱梁2区温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts3: {
        title: '箱梁3区温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts4: {
        title: '箱梁4区温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts5: {
        title: '箱梁5区温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },

    }
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
    this.resetData()
      this.setTitles()
      this.loadingData = true
      this.getDatas()
    }
  },
  created() {
    this.setTitles()
  },
  mounted() {
    this.getDatas()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resetData() {
      this.warningFlag1 = ''
      this.warningFlag2 = ''
      this.warningFlag3 = ''
      this.warningFlag4 = ''
      this.warningFlag5 = ''
    },
    setTitles() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceName = nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceName
      this.$set(this.humidity1, 'title', deviceName[0])
      this.$set(this.humidity2, 'title', deviceName[1])
      this.$set(this.SinglePieHistogramWrapOpts1, 'title', deviceName[0])
      this.$set(this.SinglePieHistogramWrapOpts2, 'title', deviceName[1])
      this.$set(this.SinglePieHistogramWrapOpts3, 'title', deviceName[2])
      this.$set(this.SinglePieHistogramWrapOpts4, 'title', deviceName[3])
      this.$set(this.SinglePieHistogramWrapOpts5, 'title', deviceName[4])
    },
    refreshData() {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    setPieHisData(datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (
        datas[data2Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (
        datas[data1Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    GetDeviceData(id) {
      return this.$http.get(
        '/statistics/DeviceData?deviceId=' + id + '&interval=BY_HOUR&insertBlankData=true'
      )
    },
    getLineDatas() {
      const routerPath = this.$route.name.split('_')
      const deviceDataName = nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const that = this
      this.$http
        .all([
          this.GetDeviceData(this.findDeviceId(deviceDataName[8])),
          this.GetDeviceData(this.findDeviceId(deviceDataName[9]))
        ])
        .then(
          that.$http.spread(function(res1, res2) {
            that.dealData(res1, res2, 'humidity1Data', that, 'warningFlag1')
          })
        )
      this.$http
        .all([
          this.GetDeviceData(this.findDeviceId(deviceDataName[6])),
          this.GetDeviceData(this.findDeviceId(deviceDataName[7]))
        ])
        .then(
          that.$http.spread(function(res1, res2) {
            that.dealData(res1, res2, 'humidity2Data', that, 'warningFlag2')
          })
        )
    },
    getDatas() {
      this.getLineDatas()
      const routerPath = this.$route.name.split('_')
      const deviceDataName =
        nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http.get(`/deviceData/Station?stationId=${stationId}`).then(res => {
        this.loadingData = false
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData1',
          this.findDeviceId(deviceDataName[0]),
          this.findDeviceId(deviceDataName[1]),
          'warningFlag1'
        )
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData2',
          this.findDeviceId(deviceDataName[2]),
          this.findDeviceId(deviceDataName[3]),
          'warningFlag2'
        )
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData3',
          this.findDeviceId(deviceDataName[4]),
          this.findDeviceId(deviceDataName[5]),
          'warningFlag3'
        )
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData4',
          this.findDeviceId(deviceDataName[6]),
          this.findDeviceId(deviceDataName[7]),
          'warningFlag4'
        )
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData5',
          this.findDeviceId(deviceDataName[8]),
          this.findDeviceId(deviceDataName[9]),
          'warningFlag5'
        )
      })
    },
    dealData(res1, res2, name, that, warnName) {
      const __data = {}
      const __data1 = {}
      const _list1 = res1.data.dataList // .splice(-10)
      _list1.forEach((el, index) => {
        __data[el.dataDate] = el.value
      })
      const _list2 = res2.data.dataList // .splice(-10)
      _list2.forEach((el, index) => {
        __data1[el.dataDate] = el.value
      })
      that[name] = {
        data1: __data,
        data2: __data1
      }
      if (res1.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res1.data.errorLevel
      }
      if (res2.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res2.data.errorLevel
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.anchor-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 4) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
    .divice-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;
    }
    .divice-block-1 {
      width: 75%;
      height: 100%;
    }
    .divice-block-2 {
      width: 24%;
      height: 100%;
    }
  }
  .divice-block-line {
    width: 100%;
    height: calc(50% - 10px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    &-item {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      width: calc((100% / 3) - 10px);
      align-items: stretch;
      background-color: rgba(255, 255, 255, 0.6);
      .divice-block-multi-item {
        width: calc(50% - 7px);
      }
    }
    .divice-block-line-item-col1 {
      width: calc(100% / 3 - 8px);
      .divice-block-multi-item {
        width: 100%;
      }
    }
    .divice-block-line-item-col {
      width: calc(100% / 3 * 2 - 8px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-top {
        display: flex;
        justify-content: space-between;
        height: 100%;
        &-in {
          display: flex;
          width: calc(50% - 7px);
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
